module.exports = __webpack_public_path__ + "static/media/decline.e4c467a3.svg";